<label><slot></slot><input class="is-hidden" type="file" accept=".jpg, .jpeg, .png" @change="loadImage"></label>